/* Copyright (c) 2017 Backpack Health LLC */

import { authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';
import { IJewelryProvider } from '../models/JewelryProvider';

export default {

  getAllProviders(profileId: number, callback) {
    return authorizedApiRequest('get', `profiles/${profileId}/jewelryProviders`)
      .end((err, res) => {
        const data: IJewelryProvider[] = res.body.data;
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, data);
      });
  },

  addToShareCard(profileId: number, shareCardId: number, orderNumber: string, stickyjId: string, callback) {
    return authorizedApiRequest('put', `profiles/${profileId}/shareCards/${shareCardId}/stickyjAccessUrl`)
      .send({
        order_number: orderNumber,
        stickyj_id: stickyjId,
      })
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, null);
      });
  },

};
